import styled, { css } from 'styled-components';

export const Container = styled.div<{ $isExpanded?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  overscroll-behavior: contain;

  ${({ $isExpanded }) =>
    $isExpanded
      ? css`
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          touch-action: pan-y;
          padding: 56px 100px 34px;
          margin: -16px -100px -34px;
          width: calc(100% + 200px);
          height: calc(100% + 50px);
        `
      : ''}
`;

const CARD_WIDTH_DECREMENT = 20;
const CARD_PEEK_AMOUNT = 30;
const CARD_EXPANDED_GAP = 15;

export const CardStack = styled.div<{ $isExpanded?: boolean }>`
  position: relative;
  width: 100%;
  max-width: 382px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Card = styled.div<{
  $stackPosition: number;
  $isActive: boolean;
  $isExpanded?: boolean;
}>`
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;

  ${({ $stackPosition, $isExpanded }) => {
    if ($stackPosition === 0) {
      return css`
        position: relative;
        z-index: 20;
        ${$isExpanded ? 'order: 1;' : ''}
      `;
    }

    if ($isExpanded) {
      return css`
        position: relative;
        width: 100%;
        z-index: ${10 - $stackPosition};
        order: ${-$stackPosition};
        margin-bottom: ${CARD_EXPANDED_GAP}px;
        transition: all 0.3s ease-out;
      `;
    }

    const peekOffset = $stackPosition * CARD_PEEK_AMOUNT;
    const widthReduction = $stackPosition * CARD_WIDTH_DECREMENT;
    return css`
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - ${widthReduction}px);
      bottom: ${peekOffset}px;
      z-index: ${20 - $stackPosition};
      transition: bottom 0.3s ease-out, width 0.3s ease-out;
    `;
  }}
`;

export const ScrollableContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
